import {inject} from '@angular/core';
import {MessageService} from 'primeng/api';
import {CanActivateFn} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {getLightTokenFromUrl} from "@adlatus-gui/shared";


export const lightGuard: CanActivateFn = async (route, state) => {
  const messageService = inject(MessageService);
  const translateService = inject(TranslateService);

  const token = getLightTokenFromUrl();
  if (!token) {
    messageService.add({
      severity: 'error',
      sticky: true,
      summary: translateService.instant('forbidden.summary'),
      detail: translateService.instant('light_route_requires_token')
    });

    return false;
  }

  return true;
};
